module.exports = __webpack_public_path__ + "img/node_white.886fd865.png";